export type AssetMap = Partial<Record<string, HTMLImageElement>>;

const FILES: Record<string, string> = {
  "player-0": "/game/player-0.png",
  "player-1": "/game/player-1.png",
  "player-2": "/game/player-2.png",
  "player-3": "/game/player-3.png",
  "tree-pine": "/game/tree-pine.png",
  "tree-hemlock": "/game/tree-hemlock.png",
  snow: "/game/snow.png",
  "snow-terrain": "/game/snow-terrain.png",
  "snow-noise": "/game/snow-noise.png",
  jump: "/game/jump.png",
  "rock-0": "/game/rock-0.png",
  "rock-1": "/game/rock-1.png",
  "rock-2": "/game/rock-2.png",
  "rock-3": "/game/rock-3.png",
  "food-hotdog": "/game/food-hotdog.png",
  "food-burger": "/game/food-burger.png",
};

function loadImage(src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.decoding = "async";
    img.onload = () => {
      const done = () => resolve(img);
      if (typeof img.decode === "function") {
        void img.decode().then(done, done);
      } else {
        done();
      }
    };
    img.onerror = () => reject(new Error(`Failed to load ${src}`));
    img.src = src;
  });
}

export async function loadAssets(): Promise<AssetMap> {
  const entries = await Promise.all(
    Object.entries(FILES).map(async ([key, src]) => {
      try {
        return [key, await loadImage(src)] as const;
      } catch {
        return [key, undefined] as const;
      }
    }),
  );
  const map: AssetMap = {};
  for (const [key, img] of entries) {
    if (img) map[key] = img;
  }
  return map;
}
